import React from "react";
import SlideUpOnScroll from "./slide-up";
import './page-title.css';

class PageTitle extends React.Component {


    render() {
        return (
            <div className={`page-title flex-column-centered section ${this.props.className || ''}`} >
                <div className='section-title t2 text-center space-above-page-title'>
                    <SlideUpOnScroll>{this.props.title}</SlideUpOnScroll>
                </div>

                <div className='page-subtitle b1'>
                    <SlideUpOnScroll>
                        {this.props.subtitle}
                    </SlideUpOnScroll>
                </div>
            </div>
        );
    }
}

export default PageTitle;